import { cn } from "@/shared/lib/utils";
import { ChevronDown } from "lucide-react";
import * as React from "react";

/**
 * Stylovaný nativní <select> v shadcn-kompatibilním designu.
 * Používá se pro filtry stavů apod., kde nepotřebujeme plnohodnotný
 * Radix combobox. Visuálně se liší od shadcn Select tím, že renderuje
 * nativní dropdown (OS level), což je přátelštější pro mobily.
 */
export const NativeSelect = React.forwardRef<
  HTMLSelectElement,
  React.SelectHTMLAttributes<HTMLSelectElement>
>(({ className, children, ...props }, ref) => (
  <div className="relative">
    <select
      ref={ref}
      className={cn(
        "flex h-9 w-full appearance-none rounded-md border border-input bg-background px-3 pr-8 text-sm ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
        className,
      )}
      {...props}
    >
      {children}
    </select>
    <ChevronDown
      className="pointer-events-none absolute right-2.5 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground"
      aria-hidden="true"
    />
  </div>
));
NativeSelect.displayName = "NativeSelect";
